export function initialSelectedIdsFromAccepted(
  standards: ReadonlyArray<{ id: string; isAccepted?: boolean | null }>
): Set<string> {
  const ids = new Set<string>()
  for (const standard of standards) {
    if (standard.isAccepted === true) {
      ids.add(standard.id)
    }
  }
  return ids
}

function areSetsEqual(
  previousSelectedIds: Set<string>,
  next: Set<string>
): boolean {
  if (previousSelectedIds.size !== next.size) {
    return false
  }
  for (const value of previousSelectedIds) {
    if (!next.has(value)) {
      return false
    }
  }
  return true
}

export function reconcileSelectedIdsWithLocks(
  previousSelectedIds: Set<string>,
  currentStandardIds: string[],
  lockedIds: Set<string>
): Set<string> {
  const currentIds = new Set(currentStandardIds)
  const next = new Set(
    [...previousSelectedIds].filter((id) => currentIds.has(id))
  )
  for (const lockedId of lockedIds) {
    next.add(lockedId)
  }

  // Preserve referential equality when nothing changed so React effects that sync
  // selection do not loop on identical Set contents.
  return areSetsEqual(previousSelectedIds, next) ? previousSelectedIds : next
}

export function toggleSelectedIdWithLocks(
  previousSelectedIds: Set<string>,
  standardId: string,
  checked: boolean,
  lockedIds: Set<string>
): Set<string> {
  if (!checked && lockedIds.has(standardId)) {
    return new Set(previousSelectedIds)
  }
  const next = new Set(previousSelectedIds)
  if (checked) {
    next.add(standardId)
  } else {
    next.delete(standardId)
  }
  for (const lockedId of lockedIds) {
    next.add(lockedId)
  }
  return next
}

export function applySelectAllWithLocks(
  checked: boolean,
  sortedStandardIds: string[],
  lockedIds: Set<string>,
  retainedIds: Set<string> = new Set()
): Set<string> {
  if (checked) {
    return new Set(sortedStandardIds)
  }
  const next = new Set(lockedIds)
  for (const retainedId of retainedIds) {
    next.add(retainedId)
  }
  return next
}
